// extracted by mini-css-extract-plugin
export default {"customBtn":"LoginForm_customBtn__wO0kq","pClr":"LoginForm_pClr__mrD3a","chkBox":"LoginForm_chkBox__zZBhU"};